<template>
    <div class="h-full w-full">
        <widget-table :reportItemList="reportItemList" :showReorderButton="showReorderButton" :reportId="reportId" :edit="edit" @updateReportItemList="updateReportItemList" ref="widgetTable">
            <template v-slot:action="{row}">
                <span>
                    <i class="vc-icon-recycle-bin cursor-pointer text-xl text-red" @click="onReportDelete(row)"></i>
                </span>
            </template>
        </widget-table>
        <delete-dialog
            v-if="showDeleteDialog"
            :visible.sync="showDeleteDialog"
            :config="{descriptionIcon: ''}"
            :description="$t('report.deleteReportItemConfirmation')"
            @on-close="onCancelDelete"
            @on-cancel="onCancelDelete"
            @on-confirm="deleteReportItem"
        />
    </div>
</template>

<script>
import WidgetTable from '@/modules/reports/components/WidgetTable.vue'
import ButtonIcon from "@/modules/common/components/ButtonIcon"
import { Notification } from 'element-ui'
import DeleteDialog from "@/components/Dialogs/DeleteDialog"
import { reportApi } from '@/modules/reports/services/reportService'
import { REPORT_ITEM_STATUS_ID_DISABLED } from '@/enum/reportStatuses'

export default {
    components: {
        WidgetTable,
        ButtonIcon,
        DeleteDialog
    },
    props: {
        showReorderButton: {
            type: Boolean,
            default: false
        },
        reportId: {
            type: [Number, String],
            default: ''
        },
        edit: {
            type: Boolean,
            default: false
        },
        reportData: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            showDeleteDialog: false,
            localRowData: null,
            reportItemList: []
        }
    },
    methods: {
        async onReportDelete (rowData) {
            const isExist = await this.checkIfWidgetExistInScheduleList(rowData)
            if (isExist) {
                Notification.warning(this.$t('report.deleteWidget.errorMsg'))
                return
            }

            this.localRowData = rowData

            if (this.edit) {
                this.showDeleteDialog = true
            } else {
                this.deleteReportItem()
            }
        },
        validate () {
            return this.reportItemList.length
        },
        async checkIfWidgetExistInScheduleList (rowData) {
            let isWidgetExistInScheduleList = false
            this.reportData.ReportTriggerList.forEach(el => {
                el.ReportTriggerCondition.forEach(el => {
                    isWidgetExistInScheduleList = el.ReportTriggerConditionFilter.some(el => el.WidgetID === rowData.WidgetID)
                })
            })
            return isWidgetExistInScheduleList
        },
        async deleteReportItem () {
            const currentIndex = this.localRowData.index - 1
            
            if (this.edit) {
                const activeItem = this.reportItemList[currentIndex]
                reportApi.reportItemChangeStatus({
                    ReportItemID: activeItem.ReportItemID,
                    ReportItemStatusID: REPORT_ITEM_STATUS_ID_DISABLED
                })
            }

            this.reportItemList.splice(currentIndex, 1)
            this.$emit('updateReportData', {
                ReportItemList: this.reportItemList
            })

            Notification.success(this.$t('general.notification.success'))
            this.$refs.widgetTable.reInitCheckboxes()
            if (this.edit) {
                this.onCancelDelete()
            }
        },
        onCancelDelete () {
            this.showDeleteDialog = false
        },
        updateReportItemList (data) {
            this.reportItemList.push(data)
            this.$emit('updateReportData', {
                ReportItemList: this.reportItemList
            })
        },
        translateTemplateNameContentTag(item) {
            return this.$te(item.TemplateNameContentTag) ? this.$t(item.TemplateNameContentTag) : item.WidgetTitle
        }
    },
    mounted () {
        this.reportItemList = this.reportData.ReportItemList.map(el => {
            el.WidgetTitle = this.translateTemplateNameContentTag(el)

            return el
        })
    }
}
</script>
